export const INVITATIONS_QUERY_KEY = ['invitations'] as const;
